import React, { useEffect, useState } from "react";
import { DateRangePicker } from "mui-daterange-picker";
import styles from './DateRangeComponent.module.css';
import rightArrow from "../Assets/Images/rightArrow.png";

// type DateOrPlaceholder = string | null;

interface DateRangeComponentProps {
    callback: (range:any)=>void;
    defaultStartDate?: Date | null;
    defaultEndDate?: Date | null;
    minDate?: Date | string;
    maxDate?: Date | string;
 }

const DateRangeComponent: React.FC<DateRangeComponentProps> = ({ callback, defaultStartDate, defaultEndDate, minDate, maxDate}) => {
    const [open, setOpen] = React.useState(false);
    const [startDate, setStartDate] = useState<Date | null | undefined>(null);
    const [endDate, setEndDate] = useState<Date | null | undefined>(null);
    const [startDisplay, setStartDisplay] = useState<string>("Start Date");
    const [endDisplay, setEndDisplay] = useState<string>("End Date");

    useEffect(()=>{
        let startDisplay = startDate
        ? startDate.toLocaleDateString()
        : "Start Date";
        let endDisplay = endDate
        ? endDate.toLocaleDateString()
        : "End Date";
        setStartDisplay(startDisplay);
        setEndDisplay(endDisplay);
    },[startDate,endDate])

    useEffect(()=>{
       setStartDate(defaultStartDate)
       setEndDate(defaultEndDate)
    },[defaultStartDate,defaultEndDate])

    // const startDisplay: DateOrPlaceholder = startDate
    //     ? startDate.toLocaleDateString()
    //     : "Start Date";

    // const endDisplay: DateOrPlaceholder = endDate
    //     ? endDate.toLocaleDateString()
    //     : "End Date";

    const toggle = () => setOpen(!open);

    const dateRangeHandler = (range: any) => {
        setStartDate(range.startDate);
        setEndDate(range.endDate);
        callback(range)
        // console.log("Start Date:", range.startDate);
        // console.log("End Date:", range.endDate);
    }

    useEffect(() => {
        (endDate && open) && setOpen(false)
    }, [endDate])

    return (
        <div className="dateRangewrap">
            <div className={`${styles.Rectangle1057}`} onClick={toggle}>
                <span className={styles.Budget}>{startDisplay}</span>
                <span className={styles.Budget1}>to</span>
                <span className={styles.Budget}>{endDisplay}</span>
                <div className={styles.Rectangle1056}>
                    <span className={styles.Readmore1}>Apply</span>
                    <img src={rightArrow} alt="" className={styles.icon20arrow} />
                </div>
            </div>
            <>
                <DateRangePicker
                    open={open}
                    toggle={toggle}
                    onChange={(range) => dateRangeHandler(range)}
                    wrapperClassName={"dateRangeWrapper"}
                    definedRanges={[]}
                    minDate={minDate}
                    maxDate={maxDate}
                />
            </>
        </div>
    );
};

export default DateRangeComponent;
